export default __webpack_public_path__ + "static/media/My biggest Flex.40e43e3b.mp4";